module.exports = __webpack_public_path__ + "img/astrobabe_back.6fba3762.jpg";